import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import { navigateTo } from "gatsby-link"
import Helmet from 'react-helmet';
import github from '../img/github-icon.svg';
import logo from '../img/logo.svg';
import CmsScript from '../components/CmsScript';
import Logo from '../components/logo/Logo';
import Footer from '../components/footer/Footer'
import ScrollComponent from '../components/ScrollComponent';
import TrackerScript from '../components/TrackerScript';
import './all.scss';

const navbarInvertThreshold = 500;

export class Navbar extends ScrollComponent {
  constructor() {
    super();
    this.state = {
      inverted: false,
      logoClass: 'hidden'
    };
  }

  onScroll(event, top) {
    let invert = top >= navbarInvertThreshold;

    if (invert != this.state.inverted) {
      this.setState({
        inverted: invert,
        logoClass: invert ? 'flip-in-x' : 'flip-out-x'
      });
    }
  }

  render() {
    return <nav className={'fixed-top navigation is-transparent ' + (this.state.inverted ? 'inverse' : '')}>
      <div className="row">
        <div className="d-none d-md-block col-md-2 col-lg-4">
          <a href="/" className="circle-wrapper">
            <div className="circle">
              <i className="fancy">RG</i>
            </div>
          </a>
          <i className="catch-phrase">- when performance counts!</i>
        </div>

        <div className="col-xl-3 d-none d-xl-block text-center">
          <div className={'text-center animate animate-delay-1x logo ' + this.state.logoClass}>
            <Logo size="md" />
          </div>
        </div>

        <div className="col-sm-12 col-md-10 col-lg-8 col-xl-5 nav-links cushy-right">
          <Link className="navbar-item" to="/">
            <i className="fa fa-home" aria-hidden="true"></i> Home
          </Link>
          <Link className="navbar-item" to="/resume" activeClassName="active">
            <i className="fa fa-file-text-o" aria-hidden="true"></i> Resume
          </Link>
          <Link className="navbar-item" to="/portfolio" activeClassName="active">
            <i className="fa fa-folder-open-o" aria-hidden="true"></i> Portfolio
          </Link>
          <Link className="navbar-item" to="/blog" activeClassName="active">
            <i className="fa fa-user-o" aria-hidden="true"></i> Blog
          </Link>
          <button className="btn btn-outline-primary btn-special" onClick={() => navigateTo('/contact')}>
            <i className="fa fa-envelope-o" aria-hidden="true"></i> Contact
          </button>
        </div>
      </div>
    </nav>
  };
};

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet title="Rusty Green" />
    <Navbar />
    <div>{children()}</div>

    <Footer />
    <CmsScript />
    <TrackerScript />

    <link href="https://fonts.googleapis.com/css?family=Rock+Salt" rel="stylesheet" lazyload />
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js